import type { ICareerSubMenu } from './career-subMenu.types'

export const CAREER_SUB_MENU_ITEMS: ICareerSubMenu = [
  { label: 'career.submenu.latestOffers', hash: 'career.submenu.hash.latestOffers' },
  { label: 'career.submenu.hireAreas', hash: 'career.submenu.hash.hireAreas' },
  { label: 'career.submenu.aboutUs', hash: 'career.submenu.hash.aboutUs' },
  { label: 'career.submenu.benefits', hash: 'career.submenu.hash.benefits' },
  { label: 'career.submenu.process', hash: 'career.submenu.hash.process' },
  { label: 'career.submenu.team', hash: 'career.submenu.hash.team' },
  { label: 'career.submenu.faq', hash: 'career.submenu.hash.faq' },
  { label: 'career.submenu.offices', hash: 'career.submenu.hash.offices' },
]

